import type React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLazyGetNotificationsQuery } from 'src/api/notifications.api';
import { formatRelativeTime } from 'src/utils/formatRelativeTime';
import { NotificationType } from 'src/types/Notification';
import { ROUTES } from '../../constants/routes';
interface NotificationDropdownProps {
  onClose: () => void;
}

export const NotificationDropdown: React.FC<NotificationDropdownProps> = ({ onClose }) => {
  const [getNotifications, { data, isLoading }] = useLazyGetNotificationsQuery();
  const [notificationsData, setNotificationsData] = useState<any[]>([]);

  useEffect(() => {
    getNotifications();
  }, [getNotifications]);

  useEffect(() => {
    if (data) {
      const formattedNotifications =
        data.results.map(notification => ({
          notificationid: notification.id,
          type: NotificationType[notification.type as keyof typeof NotificationType] || notification.type,
          message: notification.message,
          updated_at: notification.updated_at,
        })) || [];
      setNotificationsData(
        formattedNotifications.length > 5 ? formattedNotifications.slice(0, 5) : formattedNotifications,
      );
    }
  }, [data]);

  const displayedNotifications = notificationsData;

  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate(ROUTES.NOTIFICATIONS);
    onClose();
  };

  return (
    <>
      <div className="fixed inset-0 bg-opacity-30 z-40" onClick={onClose}></div>
      <div className="absolute mt-3 right-0 top-15 w-80 bg-white border border-gray-200 rounded-xl z-50 shadow-lg">
        <div className="bg-white rounded-xl m-3">
          <div className="m-3 font-bold text-lg text-deep-blue">Notifications</div>
          <hr className="h-px bg-gray-200 border-0 dark:bg-gray-300 mb-2" />
          {isLoading ? (
            <div className="p-4 max-w-sm w-full mx-auto">
              <div className="animate-pulse flex space-x-4">
                <div className="rounded-full bg-slate-200 h-10 w-10"></div>
                <div className="flex-1 space-y-6 py-1">
                  <div className="space-y-3">
                    <div className="grid grid-cols-3 gap-4">
                      <div className="h-2 bg-slate-200 rounded col-span-2"></div>
                      <div className="h-2 bg-slate-200 rounded col-span-1"></div>
                    </div>
                  </div>
                  <div className="h-2 bg-slate-200 rounded"></div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {displayedNotifications.map(notification => (
                <div
                  key={notification.notificationid}
                  className="bg-white rounded-xl pl-4 pr-1 py-4 mb-1 hover:bg-secondary-blue"
                >
                  <div className="flex flex-1 justify-between">
                    <div className="flex flex-col">
                      <div className="font-bold text-sm">{notification.type}</div>
                      <div className="font-medium text-sm text-primary-light-grey">{notification.message}</div>
                    </div>
                    <div className="ml-4">
                      <div className="font-medium text-sm text-primary-light-grey w-16">
                        {formatRelativeTime(notification.updated_at, false)}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="flex justify-center mt-2">
                <button
                  type="button"
                  className="bg-primary-blue rounded-lg py-2 px-8 font-bold text-white text-sm w-full max-w-xs"
                  onClick={handleNavigation}
                >
                  See All
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
